// ── ReportBuilderPage ──
import { useState, useEffect, useMemo } from "react";
import { B } from "../../../shared/theme";
import { exportCSV, fmt, fmtDate } from "../../../shared/format";
import { Badge, Btn, Card, ErrorMsg, FSelect, Field, Pagination, SectionHeader, Spinner } from "../../../shared/ui";
import { useApp } from "../../../shared/appContext";

// Report config (moved from App.js — used only here)
const REPORT_SOURCES = [
              { key:"loans", label:"Loans", endpoint:"getLoans", filename:"loans.csv", view:true, supportsAsOf:true, fields:[
              { key:"loannumber", label:"Loan #", type:"text" },
              { key:"companyname", label:"Company", type:"text" },
              { key:"accountnumber", label:"Account #", type:"text" },
              { key:"state", label:"State", type:"text" },
              { key:"loanstatus", label:"Status", type:"badge" },
              { key:"delinquencystatus", label:"Delinquency", type:"badge" },
              { key:"daysdelinquent", label:"Days Delinquent", type:"number" },
              { key:"RiskRating", label:"Risk Rating", type:"number" },
              { key:"fundnames", label:"Fund(s)", type:"text" },
              { key:"originalfundingdate", label:"Orig Funding", type:"date" },
              { key:"originalmaturitydate", label:"Orig Maturity", type:"date" },
              { key:"maturitydate", label:"Maturity", type:"date" },
              { key:"facilitytype", label:"Facility Type", type:"text" },
              { key:"collateraltype", label:"Collateral Type", type:"text" },
              { key:"termmonths", label:"Term (mo)", type:"number" },
              { key:"margin", label:"Margin", type:"number" },
              { key:"commitmentamount", label:"Commitment", type:"money" },
              { key:"fundedtermfundings", label:"Funded Terms", type:"money" },
              { key:"fundeddraws", label:"Funded Draws", type:"money" },
              { key:"receivedprinpmts", label:"Principal Received", type:"money" },
              { key:"loanbalancebod", label:"Balance BOD", type:"money" },
              { key:"loanbalanceeod", label:"Loan Balance", type:"money" },
              { key:"bsloanbalanceeod", label:"BS Loan Balance", type:"money" },
              { key:"ea_totalcollateralvalue", label:"Collateral", type:"money" },
              { key:"excessavailability", label:"Excess Avail", type:"money" },
              { key:"industry", label:"Industry", type:"text" },
              { key:"participationrole", label:"Participation Role", type:"text" },
              { key:"ratetype", label:"Rate Type", type:"text" },
              { key:"rateindex", label:"Rate Index", type:"text" },
              { key:"nextscheddate", label:"Next Sched Date", type:"date" },
              { key:"nextschedamount", label:"Next Sched Amount", type:"money" },
              { key:"lastpmtscheddate", label:"Last Paid Sched Date", type:"date" },
              { key:"currentindexrate", label:"Current Index Rate", type:"number" },
              { key:"totalreceivedpmts", label:"Total Received", type:"money" },
              { key:"collateralasofdate", label:"Collateral As-of Date", type:"date" },
              { key:"grossavailabilityreserves", label:"Gross Avail Reserve", type:"money" },
              { key:"overadvanceallowance", label:"Over Advance Allowance", type:"money" },
              { key:"RiskRatingDate", label:"Risk Rating Date", type:"date" },
              { key:"ar_grossamount",label:"AR: Gross",type:"money"},{key:"ar_ineligibleamount",label:"AR: Ineligible",type:"money"},{key:"ar_eligibleamount",label:"AR: Eligible",type:"money"},{key:"ar_advancerate",label:"AR: Advance Rate",type:"number"},{key:"ar_otherreserves",label:"AR: Other Reserves",type:"money"},{key:"ar_collateralvalue",label:"AR: Collateral Value",type:"money"},
              { key:"inv_grossamount",label:"Inventory: Gross",type:"money"},{key:"inv_ineligibleamount",label:"Inventory: Ineligible",type:"money"},{key:"inv_eligibleamount",label:"Inventory: Eligible",type:"money"},{key:"inv_advancerate",label:"Inventory: Advance Rate",type:"number"},{key:"inv_otherreserves",label:"Inventory: Other Reserves",type:"money"},{key:"inv_collateralvalue",label:"Inventory: Collateral Value",type:"money"},
              { key:"me_grossamount",label:"M&E: Gross",type:"money"},{key:"me_ineligibleamount",label:"M&E: Ineligible",type:"money"},{key:"me_eligibleamount",label:"M&E: Eligible",type:"money"},{key:"me_advancerate",label:"M&E: Advance Rate",type:"number"},{key:"me_otherreserves",label:"M&E: Other Reserves",type:"money"},{key:"me_collateralvalue",label:"M&E: Collateral Value",type:"money"},
              { key:"re_grossamount",label:"Real Estate: Gross",type:"money"},{key:"re_ineligibleamount",label:"Real Estate: Ineligible",type:"money"},{key:"re_eligibleamount",label:"Real Estate: Eligible",type:"money"},{key:"re_advancerate",label:"Real Estate: Advance Rate",type:"number"},{key:"re_otherreserves",label:"Real Estate: Other Reserves",type:"money"},{key:"re_collateralvalue",label:"Real Estate: Collateral Value",type:"money"},
              { key:"loc_grossamount",label:"LC: Gross",type:"money"},{key:"loc_ineligibleamount",label:"LC: Ineligible",type:"money"},{key:"loc_eligibleamount",label:"LC: Eligible",type:"money"},{key:"loc_advancerate",label:"LC: Advance Rate",type:"number"},{key:"loc_otherreserves",label:"LC: Other Reserves",type:"money"},{key:"loc_collateralvalue",label:"LC: Collateral Value",type:"money"},
              { key:"reportasofdate", label:"Report As-of Date", type:"date" },
              { key:"aggregateinventoryreserve",  label:"Agg Inventory Reserve",  type:"money" },
              { key:"aggregateinventorysublimit", label:"Agg Inventory Sublimit",  type:"money" },

            ]},
        { key:"accounts", label:"Accounts", endpoint:"getAccounts", filename:"accounts.csv", fields:[
          { key:"accountnumber", label:"Account #", type:"text" },
          { key:"companyname", label:"Company", type:"text" },
          { key:"accountstatus", label:"Status", type:"badge" },
          { key:"avgriskrating", label:"Avg Risk", type:"number" },
          { key:"state", label:"State", type:"text" },
          { key:"industryname", label:"Industry", type:"text" },
          { key:"collateraltypes", label:"Collateral Types", type:"text" },
          { key:"facilitytypes", label:"Facility Types", type:"text" },
          { key:"accountcommitmentamt", label:"Commitment", type:"money" },
          { key:"totalcollateralvalue", label:"Collateral", type:"money" },
          { key:"accountbalanceeod", label:"Loan Balance", type:"money" },
          // This source reads getAccounts directly, and getAccounts has always
          // aliased the figure `bsloanbalanceeod`. It previously listed the old
          // reporting-layer name here, which this endpoint never returned — a
          // dead column: right header, empty cells. This is the key that works.
          { key:"bsloanbalanceeod", label:"BS Loan Balance", type:"money" },
          { key:"excessavailability", label:"Excess Avail", type:"money" },
          { key:"website", label:"Website", type:"text" },
        ]},
        { key:"terms", label:"Terms", endpoint:"getTerms", filename:"terms.csv", fields:[
          { key:"loannumber", label:"Loan #", type:"text" },
          { key:"companyname", label:"Account", type:"text" },
          { key:"pipelinestage", label:"Pipeline Stage", type:"badge" },
          { key:"facility_type", label:"Facility Type", type:"text" },
          { key:"term_type", label:"Term Type", type:"text" },
          { key:"collateraltype", label:"Collateral Type", type:"text" },
          { key:"rateindex", label:"Rate Index", type:"text" },
          { key:"margin", label:"Margin", type:"number" },
          { key:"commitment", label:"Commitment", type:"money" },
          { key:"newcommitmentamount", label:"New Commitment", type:"money" },
          { key:"fundingamount", label:"Funding Amt", type:"money" },
          { key:"fundingdate", label:"Funding Date", type:"date" },
          { key:"maturitydate", label:"Maturity Date", type:"date" },
        ]},
        { key:"scheduledpmts", label:"Scheduled Payments", endpoint:"getScheduledPmts", filename:"scheduled_pmts.csv", fields:[
          { key:"loannumber", label:"Loan #", type:"text" },
          { key:"companyname", label:"Account", type:"text" },
          { key:"scheduleddate", label:"Sched Date", type:"date" },
          { key:"status", label:"Status", type:"badge" },
          { key:"unscheduledpayment", label:"Unscheduled", type:"bool" },
          { key:"scheduledprincipal", label:"Principal", type:"money" },
          { key:"scheduledinterest", label:"Interest", type:"money" },
          { key:"feetype", label:"Fee Type", type:"text" },
          { key:"scheduledfee", label:"Fee", type:"money" },
          { key:"othertype", label:"Other Type", type:"text" },
          { key:"scheduledother", label:"Other", type:"money" },
          { key:"scheduledpassthrough", label:"Passthrough", type:"money" },
          { key:"totalscheduledpayment", label:"Total Sched", type:"money" },
          { key:"totalreceivedpmt", label:"Total Received", type:"money" },
        ]},
        { key:"receivedpmts", label:"Received Payments", endpoint:"getReceivedPmts", filename:"received_pmts.csv", fields:[
          { key:"loannumber", label:"Loan #", type:"text" },
          { key:"companyname", label:"Account", type:"text" },
          { key:"receiveddate", label:"Received Date", type:"date" },
          { key:"paymentapplieddate", label:"Applied Date", type:"date" },
          { key:"reversaldate", label:"Reversal Date", type:"date" },
          { key:"receivedprincipal", label:"Principal", type:"money" },
          { key:"receivedinterest", label:"Interest", type:"money" },
          { key:"receivedfee", label:"Fee", type:"money" },
          { key:"receivedother", label:"Other", type:"money" },
          { key:"receivedpassthrough", label:"Passthrough", type:"money" },
          { key:"totalreceivedpmt", label:"Total", type:"money" },
        ]},
        { key:"draws", label:"Draws", endpoint:"getDraws", filename:"draws.csv", fields:[
          { key:"loannumber", label:"Loan #", type:"text" },
          { key:"companyname", label:"Account", type:"text" },
          { key:"drawrequestedbyName", label:"Requested By", type:"text" },
          { key:"expectedfunddate", label:"Exp Fund Date", type:"date" },
          { key:"expecteddrawamount", label:"Exp Draw Amt", type:"money" },
          { key:"drawfundedbyName", label:"Funded By", type:"text" },
          { key:"fundeddate", label:"Funded Date", type:"date" },
          { key:"fundingamount", label:"Funding Amt", type:"money" },
        ]},
        { key:"chargeoffs", label:"Charge-Offs", endpoint:"getChargeOffs", filename:"chargeoffs.csv", fields:[
          { key:"loannumber", label:"Loan #", type:"text" },
          { key:"companyname", label:"Account", type:"text" },
          { key:"asofdate", label:"As-of Date", type:"date" },
          { key:"amount", label:"Amount", type:"money" },
          { key:"status", label:"Status", type:"badge" },
        ]},
        { key:"riskratings", label:"Risk Ratings", endpoint:"getRiskRatings", filename:"risk_ratings.csv", fields:[
          { key:"loannumber", label:"Loan #", type:"text" },
          { key:"companyname", label:"Account", type:"text" },
          { key:"ratingdate", label:"Rating Date", type:"date" },
          { key:"rating", label:"Rating", type:"number" },
        ]},
        { key:"contacts", label:"Contacts", endpoint:"getContacts", filename:"contacts.csv", fields:[
          { key:"firstname", label:"First Name", type:"text" },
          { key:"lastname", label:"Last Name", type:"text" },
          { key:"title", label:"Title", type:"text" },
          { key:"email", label:"Email", type:"text" },
          { key:"phone", label:"Phone", type:"text" },
          { key:"mobilephone", label:"Mobile", type:"text" },
          { key:"companyname", label:"Account", type:"text" },
        ]},
        { key:"legalevents", label:"Legal Events", endpoint:"getLegalEvents", filename:"legal_events.csv", fields:[
          { key:"companyname", label:"Account", type:"text" },
          { key:"loannumber", label:"Loan #", type:"text" },
          { key:"type", label:"Type", type:"badge" },
          { key:"startdate", label:"Start Date", type:"date" },
          { key:"enddate", label:"End Date", type:"date" },
        ]},
        { key:"covenants", label:"Covenants", endpoint:"getCovenants", filename:"covenants.csv", fields:[
          { key:"companyname", label:"Account", type:"text" },
          { key:"covenantname", label:"Covenant", type:"text" },
          { key:"covenantcategory", label:"Category", type:"text" },
          { key:"covenantfrequency", label:"Frequency", type:"text" },
          { key:"responsibleparty", label:"Responsible", type:"text" },
          { key:"covenantdirection", label:"Direction", type:"text" },
          { key:"firsttestdate", label:"First Test", type:"date" },
        ]},
        { key:"covenantcalendar", label:"Covenant Calendar", endpoint:"getCovenantCalendar", filename:"covenant_calendar.csv", fields:[
          { key:"companyname", label:"Account", type:"text" },
          { key:"covenantname", label:"Covenant", type:"text" },
          { key:"status", label:"Status", type:"badge" },
          { key:"testdate", label:"Test Date", type:"date" },
          { key:"duedate", label:"Due Date", type:"date" },
          { key:"completeddate", label:"Completed", type:"date" },
          { key:"portfoliomanagername", label:"PM", type:"text" },
          { key:"covenantvalue", label:"Value", type:"text" },
        ]},
        { key:"notes", label:"Notes", endpoint:"getNotes?all=1", filename:"notes.csv", fields:[
          { key:"createdat", label:"Date", type:"date" },
          { key:"entitytype", label:"Type", type:"text" },
          { key:"accountnumber", label:"Account #", type:"text" },
          { key:"loannumber", label:"Loan #", type:"text" },
          { key:"companyname", label:"Company", type:"text" },
          { key:"note", label:"Note", type:"text" },
          { key:"createdby", label:"Created By", type:"text" },
        ]},
        { key:"funds", label:"Funds", endpoint:"getFunds", filename:"funds.csv", fields:[
          { key:"fundname", label:"Fund Name", type:"text" },
          { key:"status", label:"Status", type:"badge" },
          { key:"startdate", label:"Start Date", type:"date" },
          { key:"enddate", label:"End Date", type:"date" },
          { key:"loancount", label:"Active Loans", type:"number" },
        ]},
      ];

const REPORT_OPS = {
        text:   [["contains","contains"],["=","equals"],["!=","not equals"],["blank","is blank"],["notblank","not blank"]],
        badge:  [["contains","contains"],["=","equals"],["!=","not equals"],["blank","is blank"],["notblank","not blank"]],
        money:  [["=","="],["!=","≠"],[">",">"],["<","<"],[">=","≥"],["<=","≤"],["between","between"],["blank","is blank"],["notblank","not blank"]],
        number: [["=","="],["!=","≠"],[">",">"],["<","<"],[">=","≥"],["<=","≤"],["between","between"],["blank","is blank"],["notblank","not blank"]],
        date:   [["on","on"],["before","before"],["after","after"],["between","between"],["blank","is blank"],["notblank","not blank"]],
        bool:   [["=","equals"]],
      };

export const ReportBuilderPage = () => {
    const { api, currentUser, view, setConfirm, delRec, audit } = useApp();
        const [saved, setSaved] = useState([]);
        const [reportId, setReportId] = useState(null);
        const [reportName, setReportName] = useState("");
        const [sourceKey, setSourceKey] = useState(REPORT_SOURCES[0].key);
        const [rows, setRows] = useState([]);
        const [loadingData, setLoadingData] = useState(false);
        const [dataErr, setDataErr] = useState(null);
        const [total, setTotal] = useState(0);
        const [colSearch, setColSearch] = useState("");
        const [cols, setCols] = useState(REPORT_SOURCES[0].fields.filter(f=>!f.legacy).slice(0,6).map(f=>f.key));
        const [filters, setFilters] = useState([]);
        const [sortKey, setSortKey] = useState("");
        const [sortDir, setSortDir] = useState("asc");
        const [page, setPage] = useState(1);
        const [busy, setBusy] = useState(false);
        const [msg, setMsg] = useState(null);
        const pageSize = 50;
        const [asofdate, setAsofdate] = useState('');

        const source = REPORT_SOURCES.find(s=>s.key===sourceKey) || REPORT_SOURCES[0];
        const serverMode = !!source.view;
        const fieldMap = useMemo(()=>Object.fromEntries(source.fields.map(f=>[f.key,f])), [source]);
        const typeOf = k => (fieldMap[k]?.type) || "text";

        const loadSaved = () => api.get("getReports").then(d=>setSaved(Array.isArray(d)?d:[])).catch(()=>setSaved([]));
        useEffect(()=>{ loadSaved(); }, []);

// Server-mode sources page/filter/sort on the server via getReportData.
    // Client-mode sources fetch the whole table once and work in JS (+ child merge).
    useEffect(()=>{
      let cancelled = false;
      setLoadingData(true); setDataErr(null);

      if (serverMode) {
        if (cols.length === 0) { setRows([]); setTotal(0); setLoadingData(false); return; }
        api.post("getReportData", {
          source: sourceKey,
          columns: cols,
          filters,
          sortkey: sortKey,
          sortdir: sortDir,
          limit: pageSize,
          offset: (page - 1) * pageSize,
          asofdate: asofdate || undefined,   
        }).then(res=>{
          if (cancelled) return;
          setRows(Array.isArray(res?.rows) ? res.rows : []);
          setTotal(res?.total || 0);
          setLoadingData(false);
        }).catch(e=>{ if(!cancelled){ setDataErr(e.message); setLoadingData(false); } });
        return ()=>{ cancelled = true; };
      }

      const rels = source.related || [];
      Promise.all([ api.get(source.endpoint), ...rels.map(r=>api.get(r.endpoint)) ])
        .then(([base, ...childArrays])=>{
          if (cancelled) return;
          let merged = Array.isArray(base) ? base : [];
          rels.forEach((rel, idx)=>{
            const childRows = Array.isArray(childArrays[idx]) ? childArrays[idx] : [];
            const map = {};
            for (const c of childRows) {
              const k = c[rel.joinField]; if (k==null) continue;
              if (!map[k]) map[k] = c;
              else if (rel.dateField) {
                const a=c[rel.dateField], b=map[k][rel.dateField];
                if (a && (!b || String(a) > String(b))) map[k]=c;
              }
            }
            merged = merged.map(row=>{
              const child = map[row[rel.parentField]] || {};
              const add = {};
              rel.fields.forEach(f=>{ add[rel.key+"_"+f.key] = child[f.key]; });
              return { ...row, ...add };
            });
          });
          setRows(merged); setLoadingData(false);
        })
        .catch(e=>{ if(!cancelled){ setDataErr(e.message); setLoadingData(false); } });
      return ()=>{ cancelled = true; };
    }, [sourceKey, serverMode,
        serverMode ? page : 0,
        serverMode ? sortKey : "",
        serverMode ? sortDir : "",
        serverMode ? JSON.stringify(filters) : "",
        serverMode ? JSON.stringify(cols) : "",
        serverMode ? (asofdate || "") : ""]);

        // Manual source change — reset the whole builder
        const changeSource = k => {
          const s = REPORT_SOURCES.find(x=>x.key===k);
          setSourceKey(k);
          setCols(s.fields.filter(f=>!f.legacy).slice(0,6).map(f=>f.key));
          setFilters([]); setSortKey(""); setSortDir("asc");
          setReportId(null); setPage(1);
          setAsofdate('');
          setColSearch("");
        };

        const evalFilter = (row, f) => {
          const type = typeOf(f.field);
          const raw = row[f.field];
          const blank = raw==null || raw==="";
          if (f.op==="blank") return blank;
          if (f.op==="notblank") return !blank;
          if (blank) return false;
          if (type==="money" || type==="number") {
            const a=parseFloat(raw), b=parseFloat(f.value), b2=parseFloat(f.value2);
            switch(f.op){ case "=":return a===b; case "!=":return a!==b; case ">":return a>b; case "<":return a<b;
              case ">=":return a>=b; case "<=":return a<=b; case "between":return a>=b&&a<=b2; default:return true; }
          }
          if (type==="date") {
            const a=String(raw).slice(0,10), b=String(f.value).slice(0,10), b2=String(f.value2).slice(0,10);
            switch(f.op){ case "on":return a===b; case "before":return a<b; case "after":return a>b;
              case "between":return a>=b&&a<=b2; default:return true; }
          }
          const a=String(raw).toLowerCase(), b=String(f.value||"").toLowerCase();
          switch(f.op){ case "contains":return a.includes(b); case "=":return a===b; case "!=":return a!==b; default:return true; }
        };

        const result = useMemo(()=>{
          let r = rows.filter(row => filters.every(f => !f.field ? true : evalFilter(row,f)));
          if (sortKey) {
            const t = typeOf(sortKey);
            r = [...r].sort((a,b)=>{
              let av=a[sortKey], bv=b[sortKey];
              if (av==null) return 1; if (bv==null) return -1;
              let cmp;
              if (t==="money"||t==="number") cmp=(parseFloat(av)||0)-(parseFloat(bv)||0);
              else cmp=String(av).localeCompare(String(bv));
              return sortDir==="asc"?cmp:-cmp;
            });
          }
          return r;
        }, [rows, filters, sortKey, sortDir, sourceKey]);

        const clientResult = useMemo(()=>{
            if (serverMode) return rows;
            let r = rows.filter(row => filters.every(f => !f.field ? true : evalFilter(row,f)));
            if (sortKey) {
              const t = typeOf(sortKey);
              r = [...r].sort((a,b)=>{
                let av=a[sortKey], bv=b[sortKey];
                if (av==null) return 1; if (bv==null) return -1;
                let cmp;
                if (t==="money"||t==="number") cmp=(parseFloat(av)||0)-(parseFloat(bv)||0);
                else cmp=String(av).localeCompare(String(bv));
                return sortDir==="asc"?cmp:-cmp;
              });
            }
            return r;
          }, [rows, filters, sortKey, sortDir, sourceKey, serverMode]);

          useEffect(()=>{ setPage(1); }, [filters, sortKey, sortDir, sourceKey]);

        const totalRows  = serverMode ? total : clientResult.length;
        const totalPages = Math.max(1, Math.ceil(totalRows / pageSize));
        const displayed  = serverMode ? rows : clientResult.slice((page-1)*pageSize, page*pageSize);

        const toggleCol = k => setCols(c => c.includes(k) ? c.filter(x=>x!==k) : [...c, k]);
        const moveCol = (i, dir) => setCols(c => {
            const j = i + dir;
            if (j < 0 || j >= c.length) return c;
            const n = [...c];
            [n[i], n[j]] = [n[j], n[i]];
            return n;
          });
        const addFilter = () => setFilters(f => [...f, { field:"", op:"contains", value:"", value2:"" }]);
        const setFilter = (i, patch) => setFilters(f => f.map((x,idx)=> idx===i ? { ...x, ...patch } : x));
        const removeFilter = i => setFilters(f => f.filter((_,idx)=>idx!==i));
        const toggleSort = k => { if (sortKey===k) setSortDir(d=>d==="asc"?"desc":"asc"); else { setSortKey(k); setSortDir("asc"); } };

        const renderCell = (row, k) => {
          const t = typeOf(k); const v = row[k];
          if (v==null || v==="") return "—";
          if (t==="money") return fmt(v);
          if (t==="date") return fmtDate(v);
          if (t==="bool") return v ? "✓" : "—";
          if (t==="badge") return <Badge s={v} />;
          return String(v);
        };

         const doExport = async () => {
            if (cols.length === 0) return;
            const fmts = { unscheduledpayment: v => v ? "Unscheduled" : "Scheduled" };
            if (serverMode) {
              try {
            const res = await api.post("getReportData", {
              source: sourceKey,
              columns: cols,
              filters,
              sortkey: sortKey,
              sortdir: sortDir,
              limit: 100000,
              offset: 0,
              asofdate: asofdate || undefined,   // <-- ADD THIS LINE
            });
                exportCSV(res?.rows || [], cols, source.filename, fmts);
              } catch(e){ setMsg({ err:true, text:e.message }); }
            } else {
              exportCSV(clientResult, cols, source.filename, fmts);
            }
          };

        const buildBody = id => ({
          id: id || undefined, name: reportName.trim(), source: sourceKey,
          columns: JSON.stringify(cols), filters: JSON.stringify(filters),
          sortkey: sortKey || "", sortdir: sortDir || "asc",
          createdby: currentUser?.email || null
        });

        const save = async asNew => {
          if (!reportName.trim()) { setMsg({ err:true, text:"Enter a report name first." }); return; }
          const id = asNew ? null : reportId;
          setBusy(true); setMsg(null);
          try {
            const res = await api.post("saveReport", buildBody(id));
            if (res?.id && !id) setReportId(res.id);
            await audit(id?"Edited":"Added", "Reports", res?.id, (id?"Updated":"Saved")+" report: "+reportName.trim());
            await loadSaved();
            setMsg({ err:false, text:"Saved." });
          } catch(e){ setMsg({ err:true, text:e.message }); }
          setBusy(false);
        };

        const loadReport = r => {
          if (!r) return;
          setReportId(r.id); setReportName(r.name); setSourceKey(r.source);
          try { setCols(JSON.parse(r.columns||"[]")); } catch { setCols([]); }
          try { setFilters(JSON.parse(r.filters||"[]")); } catch { setFilters([]); }
          setSortKey(r.sortkey||""); setSortDir(r.sortdir||"asc"); setPage(1); setMsg(null);
        };

        const newReport = () => { setReportId(null); setReportName(""); setMsg(null); };

        const SectLbl = ({ children }) => (
          <div style={{ fontSize:11, fontWeight:700, color:B.cyanDark, textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:10, paddingBottom:6, borderBottom:"1.5px solid "+B.cyanLight }}>{children}</div>
        );

        return <>
          <SectionHeader actions={[
            <FSelect key="load" value={reportId||""} onChange={v=>loadReport(saved.find(r=>String(r.id)===String(v)))}
              options={[{value:"",label:"— Load saved report —"}, ...saved.map(r=>({value:r.id,label:r.name}))]} />,
            <Btn key="new" onClick={newReport}>New</Btn>,
            <Btn key="exp" onClick={doExport} disabled={cols.length===0}>Export CSV</Btn>,
          ]} />

          {/* Save bar */}
          <Card style={{ padding:14, marginBottom:16 }}>
            <div style={{ display:"flex", gap:8, alignItems:"center", flexWrap:"wrap" }}>
              <input value={reportName} onChange={e=>setReportName(e.target.value)} placeholder="Report name"
                style={{ flex:1, minWidth:220, padding:"7px 10px", fontSize:13, borderRadius:4, border:"1px solid #999" }} />
              <Btn variant="primary" disabled={busy} onClick={()=>save(false)}>{busy?"Saving...":(reportId?"Save":"Save")}</Btn>
              {reportId && <Btn disabled={busy} onClick={()=>save(true)}>Save As New</Btn>}
              {reportId && <Btn variant="danger" onClick={()=>setConfirm({ msg:'Delete report "'+reportName+'"?', onConfirm:()=>delRec("Reports", reportId, "Deleted report "+reportName, ()=>{ newReport(); loadSaved(); }) })}>Delete</Btn>}
              {msg && <span style={{ fontSize:12, color: msg.err?"#993C1D":"#0F6E56" }}>{msg.text}</span>}
            </div>
          </Card>
          {source.supportsAsOf && (
            <Card style={{ padding: '12px 16px', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: B.cyanDark, textTransform: 'uppercase', letterSpacing: '0.06em', flexShrink: 0 }}>
                As-of Date
              </div>
              <input
                type="date"
                value={asofdate}
                onChange={e => { setAsofdate(e.target.value); setPage(1); }}
                style={{ padding: '6px 10px', fontSize: 13, borderRadius: 4, border: '1px solid #999', background: '#fff' }}
              />
              {asofdate && (
                <button
                  onClick={() => { setAsofdate(''); setPage(1); }}
                  style={{ background: 'none', border: '0.5px solid var(--color-border-secondary)', borderRadius: 6, padding: '5px 10px', cursor: 'pointer', fontSize: 12, color: 'var(--color-text-secondary)' }}
                >
                  Clear (use current)
                </button>
              )}
              {asofdate
                ? (
                  <span style={{ fontSize: 12, padding: '3px 10px', borderRadius: 10, background: B.amberLight, color: B.amberDark, fontWeight: 600 }}>
                    Historical snapshot · {asofdate}
                  </span>
                ) : (
                  <span style={{ fontSize: 12, color: 'var(--color-text-secondary)' }}>
                    No date set — showing live current data
                  </span>
                )
              }
              <div style={{ fontSize: 11, color: 'var(--color-text-secondary)', marginLeft: 'auto' }}>
                When set, all balances, payments, draws, and collateral reflect data as of end-of-day on this date.
              </div>
            </Card>
          )}

          <div style={{ display:"grid", gridTemplateColumns:"minmax(280px,340px) 1fr", gap:16, marginBottom:16, alignItems:"start" }}>


            {/* Source + columns */}
            <Card style={{ padding:16 }}>
              <SectLbl>1 · Data Source</SectLbl>
              <FSelect value={sourceKey} onChange={changeSource} options={REPORT_SOURCES.map(s=>({value:s.key,label:s.label}))} />
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", margin:"16px 0 8px" }}>
              <div style={{ fontSize:11, fontWeight:700, color:B.cyanDark, textTransform:"uppercase", letterSpacing:"0.06em" }}>2 · Columns</div>
              <div style={{ display:"flex", gap:6 }}>
              <span onClick={()=>setCols([
                  ...source.fields.filter(f=>!f.legacy).map(f=>f.key),
                  ...((source.related||[]).flatMap(rel=>rel.fields.map(f=>rel.key+"_"+f.key)))
                ])} style={{ fontSize:11, color:B.cyan, cursor:"pointer" }}>All</span>
                <span onClick={()=>setCols([])} style={{ fontSize:11, color:"var(--color-text-secondary)", cursor:"pointer" }}>None</span>
              </div>
            </div>
            <input value={colSearch} onChange={e=>setColSearch(e.target.value)} placeholder="Search fields..."
              style={{ width:"100%", boxSizing:"border-box", padding:"6px 9px", fontSize:12, borderRadius:4, border:"1px solid #999", marginBottom:8 }} />
            {(()=>{
              const q = colSearch.trim().toLowerCase();
              const match = f => f.label.toLowerCase().includes(q);
              const byLabel = arr => [...arr].sort((a,b)=>a.label.localeCompare(b.label));
              // `legacy` fields exist only so old saved reports still resolve a
              // label; offering them again would put the retired name back into
              // new report definitions.
              const base = byLabel(source.fields.filter(f=>!f.legacy)).filter(match);
              return (
                <div style={{ display:"grid", gap:4, maxHeight:260, overflowY:"auto", paddingRight:6 }}>
                  {base.map(f=>(
                    <label key={f.key} style={{ display:"flex", alignItems:"center", gap:8, fontSize:13, cursor:"pointer" }}>
                      <input type="checkbox" checked={cols.includes(f.key)} onChange={()=>toggleCol(f.key)} /> {f.label}
                    </label>
                  ))}
                {(source.related||[]).map(rel=>{
                  const rf = byLabel(rel.fields).filter(match);
                  if (rf.length===0) return null;
                  return (
                    <div key={rel.key}>
                      <div style={{ fontSize:10, fontWeight:700, color:B.cyanDark, textTransform:"uppercase", letterSpacing:"0.05em", margin:"10px 0 4px" }}>{rel.label}</div>
                      {rf.map(f=>{
                        const k = rel.key+"_"+f.key;
                        return <label key={k} style={{ display:"flex", alignItems:"center", gap:8, fontSize:13, cursor:"pointer" }}>
                          <input type="checkbox" checked={cols.includes(k)} onChange={()=>toggleCol(k)} /> {f.label}
                        </label>;
                      })}
                    </div>
                  );
                })}
                {base.length===0 && !(source.related||[]).some(r=>r.fields.some(f=>f.label.toLowerCase().includes(q))) &&
                  <div style={{ fontSize:12, color:"var(--color-text-secondary)", padding:"6px 2px" }}>No matching fields.</div>}
                  {cols.length > 0 && <>
            <div style={{ fontSize:11, fontWeight:700, color:B.cyanDark, textTransform:"uppercase", letterSpacing:"0.06em", margin:"16px 0 8px" }}>Column Order</div>
            <div style={{ display:"grid", gap:4, maxHeight:220, overflowY:"auto", paddingRight:6 }}>
              {cols.map((k,i)=>(
                <div key={k} style={{ display:"flex", alignItems:"center", gap:6, fontSize:13 }}>
                  <span style={{ flex:1, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{i+1}. {fieldMap[k]?.label||k}</span>
                  <button onClick={()=>moveCol(i,-1)} disabled={i===0} style={{ background:"none", border:"0.5px solid var(--color-border-secondary)", borderRadius:4, padding:"2px 6px", cursor:i===0?"not-allowed":"pointer", opacity:i===0?0.4:1, fontSize:11 }}>↑</button>
                  <button onClick={()=>moveCol(i,1)} disabled={i===cols.length-1} style={{ background:"none", border:"0.5px solid var(--color-border-secondary)", borderRadius:4, padding:"2px 6px", cursor:i===cols.length-1?"not-allowed":"pointer", opacity:i===cols.length-1?0.4:1, fontSize:11 }}>↓</button>
                  <button onClick={()=>toggleCol(k)} title="Remove" style={{ background:"none", border:"0.5px solid #E24B4A", borderRadius:4, padding:"2px 6px", cursor:"pointer", fontSize:11, color:"#A32D2D" }}>✕</button>
                </div>
              ))}
            </div>
          </>}
              </div>
            );
          })()}
         
            </Card>

            {/* Filters + sort */}
            <Card style={{ padding:16 }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10, paddingBottom:6, borderBottom:"1.5px solid "+B.cyanLight }}>
                <div style={{ fontSize:11, fontWeight:700, color:B.cyanDark, textTransform:"uppercase", letterSpacing:"0.06em" }}>3 · Filters</div>
                <Btn onClick={addFilter}>+ Add Filter</Btn>
              </div>
              {filters.length===0 && <div style={{ fontSize:13, color:"var(--color-text-secondary)", marginBottom:12 }}>No filters — all rows included.</div>}
              {filters.map((f,i)=>{
                const t = typeOf(f.field);
                const ops = REPORT_OPS[t] || REPORT_OPS.text;
                const needsVal = !["blank","notblank"].includes(f.op);
                const needsTwo = f.op==="between";
                const inputType = t==="date" ? "date" : (t==="money"||t==="number") ? "number" : "text";
                return (
                  <div key={i} style={{ display:"flex", gap:6, alignItems:"center", marginBottom:8, flexWrap:"wrap" }}>
                    <div style={{ minWidth:150 }}>
                      <FSelect value={f.field} onChange={v=>setFilter(i,{ field:v, op:(REPORT_OPS[typeOf(v)]||REPORT_OPS.text)[0][0], value:"", value2:"" })}
                        options={[{value:"",label:"— Field —"}, ...source.fields.map(x=>({value:x.key,label:x.label}))]} />
                    </div>
                    <div style={{ minWidth:110 }}>
                      <FSelect value={f.op} onChange={v=>setFilter(i,{ op:v })} options={ops.map(([val,lbl])=>({value:val,label:lbl}))} />
                    </div>
                    {needsVal && <input type={inputType} value={f.value} onChange={e=>setFilter(i,{ value:e.target.value })} placeholder="Value"
                      style={{ width:130, padding:"7px 10px", fontSize:13, borderRadius:4, border:"1px solid #999" }} />}
                    {needsTwo && <input type={inputType} value={f.value2} onChange={e=>setFilter(i,{ value2:e.target.value })} placeholder="and"
                      style={{ width:130, padding:"7px 10px", fontSize:13, borderRadius:4, border:"1px solid #999" }} />}
                    <button onClick={()=>removeFilter(i)} style={{ background:"none", border:"0.5px solid #E24B4A", borderRadius:4, padding:"5px 9px", cursor:"pointer", fontSize:12, color:"#A32D2D" }}>✕</button>
                  </div>
                );
              })}
              <div style={{ marginTop:16, paddingTop:12, borderTop:"1px solid "+B.cyanLight, display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" }}>
                <div style={{ fontSize:11, fontWeight:700, color:B.cyanDark, textTransform:"uppercase", letterSpacing:"0.06em" }}>4 · Sort</div>
                <div style={{ minWidth:160 }}>
                  <FSelect value={sortKey} onChange={v=>setSortKey(v)} options={[{value:"",label:"— None —"}, ...source.fields.map(x=>({value:x.key,label:x.label}))]} />
                </div>
                {sortKey && <Btn onClick={()=>setSortDir(d=>d==="asc"?"desc":"asc")}>{sortDir==="asc"?"Ascending ▲":"Descending ▼"}</Btn>}
              </div>
            </Card>
          </div>

          {/* Preview */}
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
            <div style={{ fontSize: 13, fontWeight: 500 }}>
              Preview{' '}
              <span style={{ color: 'var(--color-text-secondary)', fontWeight: 400 }}>
                ({totalRows} row{totalRows !== 1 ? 's' : ''})
              </span>
            </div>
            {asofdate && (
              <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 8, background: B.amberLight, color: B.amberDark, fontWeight: 600 }}>
                📅 As of {asofdate}
              </span>
            )}
          </div>
          <Btn variant="primary" onClick={doExport} disabled={cols.length===0}>Export CSV</Btn>
          </div>

          {loadingData ? <Spinner /> : dataErr ? <ErrorMsg msg={dataErr} /> : cols.length===0
            ? <Card><div style={{ fontSize:13, color:"var(--color-text-secondary)", padding:12 }}>Select at least one column.</div></Card>
            : <Card style={{ overflowX:"auto" }}>
                <table style={{ width:"100%", borderCollapse:"collapse", whiteSpace:"nowrap" }}>
                  <thead><tr>
                    {cols.map(k=>(
                      <th key={k} onClick={()=>toggleSort(k)} style={{
                        textAlign: ["money","number"].includes(typeOf(k))?"right":"left",
                        padding:"8px 12px", fontSize:12, fontWeight:500, color:"var(--color-text-secondary)",
                        borderBottom:"0.5px solid var(--color-border-tertiary)", background:"var(--color-background-secondary)",
                        whiteSpace:"nowrap", cursor:"pointer", userSelect:"none"
                      }}>
                        {fieldMap[k]?.label||k}
                        <span style={{ fontSize:10, marginLeft:4, opacity: sortKey===k?1:0.3 }}>{sortKey===k?(sortDir==="asc"?"▲":"▼"):"▲"}</span>
                      </th>
                    ))}
                  </tr></thead>
                  <tbody>
                    {displayed.map((row,ri)=>(
                      <tr key={ri} onMouseEnter={e=>e.currentTarget.style.background="var(--color-background-secondary)"} onMouseLeave={e=>e.currentTarget.style.background=""}>
                        {cols.map(k=>{
                          const t = typeOf(k);
                          return <td key={k} style={{ padding:"9px 12px", fontSize:13, borderBottom:"0.5px solid var(--color-border-tertiary)", textAlign:["money","number"].includes(t)?"right":"left", fontVariantNumeric:["money","number"].includes(t)?"tabular-nums":"normal" }}>{renderCell(row,k)}</td>;
                        })}
                      </tr>
                    ))}
                    {displayed.length===0 && <tr><td colSpan={cols.length} style={{ padding:16, fontSize:13, color:"var(--color-text-secondary)", textAlign:"center" }}>No rows match the filters.</td></tr>}
                  </tbody>
                </table>
                <Pagination page={page} totalPages={totalPages} total={result.length} pageSize={pageSize} onPage={setPage} />
              </Card>
          }
        </>;
      };
